var _classCallCheck = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var axios = require('axios');

var logreq = process.env.httpsendlog;
var logmaxlen = 120;

var HttpWrapper =
/*#__PURE__*/
function () {
  "use strict";

  function HttpWrapper(opts) {
    _classCallCheck(this, HttpWrapper);

    this.provider = axios.create(Object.assign({
      headers: {
        'Content-Type': 'application/json'
      }
    }, opts));

    if (logreq) {
      this.provider.interceptors.response.use(function (response) {
        console.log("got response:", response.config.url, JSON.stringify(response.data).slice(0, logmaxlen));
        return response;
      }, function (error) {
        var errData = error.response ? error.response.data : {
          error: error.message
        };
        var errStr = (typeof errData === 'string' ? errData : JSON.stringify(errData)).slice(0, logmaxlen);
        var errUrl = error.response ? error.response.config.url : error.address;
        console.log("got response:", errUrl, "err=", errStr);
        return Promise.reject(error);
      });
    }
  }

  _createClass(HttpWrapper, [{
    key: "send",
    value: function send(url, jsonRequestData, callback) {
      this.sendPromise(url, jsonRequestData || {}).then(function (data) {
        return callback(null, data);
      }).catch(function (err) {
        return callback(err, null);
      });
    }
  }, {
    key: "sendPromise",
    value: function sendPromise(url, jsonRequestData) {
      if (logreq) {
        console.log("sending request:", url, JSON.stringify(jsonRequestData || {}).slice(0, logmaxlen));
      }

      return this.provider.post(url, jsonRequestData).then(function (res) {
        return res.data;
      }).catch(function (err) {
        return Promise.reject(err.response ? err.response.data : {
          error: err.message
        });
      });
    }
  }]);

  return HttpWrapper;
}();

module.exports = HttpWrapper;